// Phase 1A Phase 9C.2 — ACC data tier icon definitions.
//
// 4 tier glyphs — descending coverage indicators.
// Tier 1 = 4 stacked bars (full). Tier 4 = single bar with notch
// (anomaly only — does NOT imply full agent confidence).

import type { IconDef } from "./icon-types.ts";

export const DATA_TIER_ICONS: Record<string, IconDef> = {
  "data_tier.tier_1_full": {
    key: "data_tier.tier_1_full",
    shapes: [
      { type: "rect", x: 5, y: 17, width: 3, height: 3, rx: 0.4, filled: true },
      { type: "rect", x: 9.5, y: 13, width: 3, height: 7, rx: 0.4, filled: true },
      { type: "rect", x: 14, y: 9, width: 3, height: 11, rx: 0.4, filled: true },
      { type: "rect", x: 18.5, y: 5, width: 3, height: 15, rx: 0.4, filled: true },
    ],
  },
  "data_tier.tier_2_statistical": {
    key: "data_tier.tier_2_statistical",
    shapes: [
      { type: "rect", x: 5, y: 17, width: 3, height: 3, rx: 0.4, filled: true },
      { type: "rect", x: 9.5, y: 13, width: 3, height: 7, rx: 0.4, filled: true },
      { type: "rect", x: 14, y: 9, width: 3, height: 11, rx: 0.4, filled: true },
      { type: "rect", x: 18.5, y: 5, width: 3, height: 15, rx: 0.4 },
    ],
  },
  "data_tier.tier_3_pattern": {
    key: "data_tier.tier_3_pattern",
    shapes: [
      { type: "rect", x: 5, y: 17, width: 3, height: 3, rx: 0.4, filled: true },
      { type: "rect", x: 9.5, y: 13, width: 3, height: 7, rx: 0.4, filled: true },
      { type: "rect", x: 14, y: 9, width: 3, height: 11, rx: 0.4 },
      { type: "rect", x: 18.5, y: 5, width: 3, height: 15, rx: 0.4 },
    ],
  },
  "data_tier.tier_4_anomaly": {
    key: "data_tier.tier_4_anomaly",
    shapes: [
      { type: "rect", x: 5, y: 17, width: 3, height: 3, rx: 0.4, filled: true },
      { type: "rect", x: 9.5, y: 13, width: 3, height: 7, rx: 0.4 },
      { type: "rect", x: 14, y: 9, width: 3, height: 11, rx: 0.4 },
      { type: "polygon", points: "20,5 22,9 18,9", filled: true },
    ],
  },
};
